import React from 'react';
import { Mail, MessageSquare } from 'lucide-react';
import { Input } from '@/components/ui/input';
import { OnboardingFormData } from '../OnboardingWizardContent';

interface Props {
  data: OnboardingFormData;
  updateData: (updates: Partial<OnboardingFormData>) => void;
}

const StepForwardEmail: React.FC<Props> = ({ data, updateData }) => {
  return (
    <div className="space-y-6">
      <p className="text-muted-foreground">
        Where should we send conversation summaries? This email will receive daily digests 
        of chat conversations and any escalated inquiries.
      </p>

      {/* Summary Forward Email */}
      <div className="space-y-2">
        <label className="text-sm font-medium text-foreground">
          Summary Forward Email <span className="text-red-500">*</span>
        </label>
        <div className="relative">
          <Mail className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground" />
          <Input
            type="email"
            value={data.summaryForwardEmail}
            onChange={(e) => updateData({ summaryForwardEmail: e.target.value })}
            placeholder="inquiries@yourcompany.com"
            className="pl-10"
          />
        </div>
      </div>

      {/* What you'll receive */}
      <div className="bg-muted/50 rounded-lg p-4 space-y-4">
        <h4 className="font-medium text-foreground flex items-center gap-2">
          <MessageSquare className="h-5 w-5 text-brand-teal" />
          What You'll Receive
        </h4>
        <ul className="text-sm text-muted-foreground space-y-2">
          <li className="flex items-start gap-2">
            <span className="text-brand-teal">•</span>
            <span>Daily summary of all conversations</span>
          </li>
          <li className="flex items-start gap-2">
            <span className="text-brand-teal">•</span>
            <span>Immediate alerts for escalated inquiries</span>
          </li>
          <li className="flex items-start gap-2">
            <span className="text-brand-teal">•</span>
            <span>Lead capture notifications when visitors share contact details</span>
          </li>
          <li className="flex items-start gap-2">
            <span className="text-brand-teal">•</span>
            <span>Weekly analytics report with conversation insights</span>
          </li>
        </ul>
      </div>

      <div className="bg-brand-teal/5 border border-brand-teal/20 rounded-lg p-4">
        <p className="text-sm text-card-foreground">
          <strong>💡 Tip:</strong> Use a shared inbox or team email address so your 
          whole team can stay informed about customer conversations.
        </p>
      </div>
    </div>
  );
};

export default StepForwardEmail;
